import React from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite/no-important'
import { history } from '../../../../store'
import dayjs from 'dayjs'

import { colors } from '@lmc/common/constants'
import { LogSummary, ResidentPictureName } from '../../../../components/generic'

export const LogsTableItem = ({ log, residentStyle, linkEnabled }) => {
  const isDeleted = log.deleted
  const redirect = (url) => history.push(`/${url}`)

  return (
    <div className={css(classes.wrapper)}>
      <div
        className={
          !isDeleted
            ? css(classes.timeLoggedContainer)
            : css(classes.timeLoggedContainerGreyed)
        }
      >
        {dayjs(log.timeLogged).format('DD-MM-YYYY HH:mm')}
      </div>
      <ResidentPictureName
        data={log.resident}
        isLogRemoved={log.deleted}
        onSelect={redirect}
        style={residentStyle}
      />
      <LogSummary
        data={log}
        isLogRemoved={log.deleted}
        linkEnabled={linkEnabled}
        onSelect={redirect}
      />
    </div>
  )
}

const classes = StyleSheet.create({
  timeLoggedContainer: {
    marginRight: 12,
    paddingTop: 12,
    width: '20%',
  },
  timeLoggedContainerGreyed: {
    marginRight: 12,
    paddingTop: 12,
    width: '20%',
    color: colors.darkgrey,
  },
  wrapper: {
    borderBottom: '1px solid',
    borderColor: colors.grey,
    display: 'flex',
    padding: '16px 0px',
  },
})

LogsTableItem.propTypes = {
  log: PropTypes.object.isRequired,
  role: PropTypes.string,
}

export default LogsTableItem
